
// 空间管理根路径
export const ROOT_SPACE = process.env.VUE_APP_API_SPACE;
// 无人机模拟器根路径
export const ROOT_SIMULATOR = process.env.VUE_APP_API_SIMULATOR;
// 资源服务的根路径
export const ROOT_RESOURCE = process.env.VUE_APP_API_RESOURCE;

// 租户端服务的根路径，端口为30302
export const ROOT_EDUCATION = process.env.VUE_APP_API_EDUCATION;

//运营端 oms
export const ROOT_OMS = process.env.VUE_APP_API_OMS;
